import { currencyFormat } from 'common/helpers/numberHelper';

const Money = (props) => {
  const { number, settings } = props;
  const currency = currencyFormat(number, settings);
  if (number >= 0) {
    return (
      <>
        {currency.split('.')[0]}.<span>{currency.split('.')[1]}</span>
      </>
    );
  }
  return (
    <>
      ({currency.split('.')[0].replace(/-/g, '')}.
      <span>{currency.split('.')[1]}</span>)
    </>
  );
};

export default Money;
